import { FC } from "react";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import ReceiptContent from "./ReceiptContent";
import classNames from "classnames";
import AgeVerificationModal from "./age-verification-modal";
import useModalsStore from "stores/modals";
import { useIsTakeOut } from "@/stores/cash-register";
import { useAppSelector } from "@/hooks/useAppSelector";
import { selectCartProducts, selectCartDiscounts } from "@/store/cart/selectors";

const Receipt: FC = () => {
  const { t } = useTranslation();
  const products = useAppSelector(selectCartProducts);
  const discounts = useAppSelector(selectCartDiscounts);
  const { showAgeVerification, setShowAgeVerification } = useModalsStore();
  const isTakeOut = useIsTakeOut();

  return (
    <div className={styles.container}>
      <AgeVerificationModal
        showAgeVerification={showAgeVerification}
        setShowAgeVerification={setShowAgeVerification}
      />
      <h2 className={styles.title}>{t("mainPage.yourReceipt")}</h2>
      {products.length + discounts.length === 0 ? (
        <div className={styles.emptyBody}>
          <p className={classNames("h3", styles.emptyReceipt)}>
            {isTakeOut ? t("mainPage.emptyReceiptText") : t("mainPage.emptyPickupReceiptText")}
          </p>
        </div>
      ) : (
        <ReceiptContent />
      )}
    </div>
  );
};

export default Receipt;
